import { Component, Prop, Vue } from 'types-vue'

@Component
export default class DataSection extends Vue {
  
  @Prop({ required: true, type: Array }) protected elements: { name: string, value: string }[]

}